export const LegalData = [
  {
    title: 'API Terms of Service',
    url: '/legal/api-terms-of-service',
  },
  {
    title: 'Commercial Deposit Account Agreement',
    url: '/legal/commercial-deposit-account-agreement',
  },
  {
    title: 'Privacy Notice',
    url: '/legal/privacy-notice',
  },
  {
    title: 'Website Privacy Policy',
    url: '/legal/website-privacy-policy',
  },
  {
    title: 'California Consumer Privacy Policy',
    url: '/legal/california-consumer-privacy-policy',
  },
  {
    title: 'Notice to Recruiters & Staffing Agencies',
    url: '/legal/notice-to-recruiters-and-staffing-agencies',
  },
  {
    title: 'Sweep Program Network Banks',
    url: '/legal/sweep-program-network-banks',
  },
  {
    title: 'Privacy Request Form',
    url: 'https://form.asana.com/?k=UeAaCi907vcvSivY8DJmdA&d=1202588311246880',
  },
];
